export default __webpack_public_path__ + "static/media/list-view.e34c9d6d.svg";